export const categoryConfig = {
    'gen':{title:'GEN',ms:6,message:"You can select maximum 6 seat(s) only",cat_type:"gen",mds:0,card_req:false},
    'srCitizen':{title:'SrCitizen',ms:1,message:"You can select maximum 1 seat(s) only",cat_type:"srCitizen",mds:1,card_req:true,id:"srctzn_card_detail",fn:"SrCitizen Card",age_limit:60},
    'cat':{title:'CAT',ms:4,message:"You can select maximum 4 seat(s) only",cat_type:"cat","mds":1,"card_req":true,id:"cat_card_detail",fn:"Cat card Number","age_limit":12},
    '15499':{title:'RSRTC',ms:4,message:"You can select maximum 4 seat(s) only",mds:0,card_req:false}
    
    }
export const seatTabConfig = {
    seatLayout:'SELECT SEATS',
    amenities_photos: 'AMENITIES AND PHOTOS',
    reviews:'REVIEWS',
    policies:'POLICIES',
    boarding_dropping:'BOARDING AND DROPPING'

}
/*
"{"cat_type":"gen","title":"GEN","mds":0,"ms":6,"card_req":false}"
"{"cat_type":"cat","title":"CAT","mds":1,"ms":4,"card_req":true,"id":"cat_card_detail","fn":"Cat card Number","age_limit":12}"
"{"cat_type":"srCitizen","title":"SrCitizen","mds":1,"ms":1,"card_req":true,"id":"srctzn_card_detail","fn":"SrCitizen Card","age_limit":60}"
*/